import { sendAxiosRequest } from '../../utils/sendRequest';
import { api } from '../../Api';
import UrlBuilder from '../../url/UrlBulder';
import IDataObjectParams from '../../../models/params/IDataObjectParams';
import IMerchProductOrderResponse from '../../../models/responces/IMerchProductOrderResponse';
import IMerchProductOrderItem from '../../../models/restful/IMerchProductOrderItem';

export interface IApiCreateOrderItemParams {
  orderItem?: IMerchProductOrderItem;
  dataObjectParams?: IDataObjectParams;
}
const apiCreateOrderItem = (params: IApiCreateOrderItemParams) =>
  sendAxiosRequest({
    method: 'post',
    headers: { Authorization: api.getToken() },
    url: UrlBuilder.getURL({
      handler: 'order',
      action: 'createOrderItem',
      dataObjectParams: params.dataObjectParams || undefined
    }),
    data: params.orderItem,
    responseType: 'json'
  }).then(resp => resp.data) as Promise<IMerchProductOrderResponse>;
export default apiCreateOrderItem;
